export default "/fcbcac1db17390110677298f9d30eeed9c121039/bce1c79c076cfd26ce49a1f2fa85ca50.svg";